// new Aleksei
import { useQuery } from '@tanstack/react-query';
import supabase from 'sdk/api';

const getAllStores = async (limit?: number) => {
    let query = supabase
        .from('store_owners_profile')
        .select('*')
        .order('store_name', { ascending: true });

    if (limit) {
        query = query.limit(limit);
    }

    const { data, error } = await query;

    if (error) {
        throw new Error(error.message);
    }

    return data;
};

const useGetAllStores = (limit?: number) => {
    return useQuery({
        queryKey: ['stores', limit],
        queryFn: () => getAllStores(limit),
    });
};

export default useGetAllStores;